const buildPrintableDocument = (
  frameDocument: Document,
  title: string,
  codes: string[],
) => {
  frameDocument.title = title;

  const heading = frameDocument.createElement('h1');
  heading.textContent = title;
  heading.style.font = '700 18px sans-serif';

  const list = frameDocument.createElement('ul');
  list.style.font = '16px monospace';
  list.style.listStyle = 'none';
  list.style.padding = '0';
  list.style.lineHeight = '1.8';

  codes.forEach((code) => {
    const item = frameDocument.createElement('li');
    item.textContent = code;
    list.appendChild(item);
  });

  frameDocument.body.replaceChildren(heading, list);
};

export const printRecoveryCodes = (title: string, codes: string[]) => {
  const frame = document.createElement('iframe');
  frame.setAttribute('aria-hidden', 'true');
  frame.style.position = 'fixed';
  frame.style.width = '0';
  frame.style.height = '0';
  frame.style.border = '0';

  // The frame must stay in the document until the dialog closes; removing it
  // earlier cancels the job in WebKit.
  document.body.appendChild(frame);

  const frameWindow = frame.contentWindow;

  if (!frameWindow) {
    frame.remove();
    return;
  }

  buildPrintableDocument(frameWindow.document, title, codes);

  frameWindow.addEventListener('afterprint', () => frame.remove());
  frameWindow.focus();
  frameWindow.print();
};
